import { defineStore } from 'pinia'
import { ref, useContext } from '@nuxtjs/composition-api'

import { useWarningModel } from '@shared/model/'
import { checkErrorEight, checkOperationLink, checkReference } from './../index'

export const useOperationsModel = defineStore('operations', () => {
  const { route } = useContext()
  const warningModel = useWarningModel()

  const status = ref<boolean>(false)
  const referenceId = ref<string>('')

  // Проверка ошибок в операции
  const checkError = () => {
    const resStatusError: { status: boolean; text: string } = checkErrorEight(route.value.fullPath)
    const resOperation: boolean = checkOperationLink(route.value.fullPath)
    const resReference: string | null = checkReference(route.value.fullPath)

    if (resStatusError.status) {
      warningModel.toggleStatus({
        text: resStatusError.text,
        status: true
      })
    }

    if (!resStatusError.status && resOperation) {
      status.value = true
    }

    if (resReference) {
      referenceId.value = resReference
    }
  }

  return {
    status,
    referenceId,
    checkError
  }
})
